<template>
  <div class="generate-result-page">
    <!-- 导航栏 -->
    <div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
      <div class="back-btn" @click="onBack">
        <img src="@/assets/back.svg" class="back-icon" />
      </div>
      <div class="nav-title">自由拍摄</div>
    </div>

    <div class="page-body">
      <!-- 摄像头预览 -->
      <video
        ref="videoPlayer"
        autoplay
        muted
        playsinline
        class="camera-preview"
      ></video>

      <!-- 倒计时 -->
      <div class="djs" v-if="countdown">{{ countdown }}</div>

      <!-- 录制时间 / 最大 45s -->
      <div class="lzsj" v-if="isRecording">{{ formattedTime }}/00:45</div>

      <!-- 控制按钮 -->
      <div class="control-buttons">
        <button
          v-if="!isRecording"
          @click="startRecording"
          class="btn"
        ></button>
        <button v-else @click="stopRecording" class="btnStop">
          <div></div>
        </button>
      </div>
    </div>

    <!-- 提示文本 -->
    <div class="topText">
      <div>
        录制对着镜头自然说话就行。语速正常、嘴型饱满，效果会更自然。建议加些手部动作，但手不要超过下巴。不用死记硬背文案，轻松随意表达就好
      </div>
    </div>

    <!-- 加载遮罩 -->
    <!-- <loadingVue v-model="isLoading" text="文件上传中..." /> -->

    <!-- 人脸引导区域（PNG 图片） -->
    <!-- <img src="@/assets/aiVideo/rxlk.png" alt="人脸区域" class="rxlk" /> -->
    <!-- 确认弹窗 -->
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <!-- 弹窗内容（阻止冒泡） -->
      <div class="modal-content" @click.stop>
        <div class="modal-title">提示</div>
        <div class="modal-body">
          <div class="modal-text">
            请流畅朗读提示词的内容，录制定制数字人的形象视频，要保证人脸露出哦。
          </div>
        </div>
        <div class="modal-confirm-div">
          <div @click="handleConfirm" class="modal-confirm-btn">我知道了</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import loadingVue from "@/components/loadingVue.vue";
import { voUpload, voDelete, convertWebmToMp4 } from "@/api";
import { Toast } from "vant";

export default {
  name: "authorizedVideo",
  // components: { loadingVue },
  data() {
    return {
      stream: null,
      mediaRecorder: null,
      isRecording: false,
      recordedChunks: [],
      countdown: "",
      countdownTimer: null,
      recordingTime: 0,
      recordingTimer: null,
      showModal: false,
	  currentPlatform: '',
      // isLoading: false,
    };
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.recordingTime / 60)
        .toString()
        .padStart(2, "0");
      const seconds = (this.recordingTime % 60).toString().padStart(2, "0");
      return `${minutes}:${seconds}`;
    },
  },
  beforeDestroy() {
    this.cleanup();
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
    if (this.recordingTimer) {
      clearInterval(this.recordingTimer);
      this.recordingTimer = null;
    }
  },
  async mounted() {
	  document.title = "自由拍摄";
	  this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
    // await this.startCamera();
    this.showModal = true;
  },
  methods: {
    onBack() {
      this.$router.back();
    },
    closeModal() {
      this.showModal = false;
      this.onBack();
    },
    async handleConfirm() {
      this.showModal = false;
      await this.startCamera();
    },
    startCamera() {
      // try {
      navigator.mediaDevices
        .getUserMedia({
          video: {
            width: { ideal: 1280 }, // 理想宽度
            height: { ideal: 720 }, // 理想高度
            frameRate: { ideal: 30 },
            facingMode: "user", // 前置摄像头
          },
          audio: true,
        })
        .then((stream) => {
          this.stream = stream;
          this.$refs.videoPlayer.srcObject = stream;
          const mimeType = MediaRecorder.isTypeSupported("video/mp4")
            ? "video/mp4"
            : MediaRecorder.isTypeSupported("video/webm")
            ? "video/webm"
            : "video/mp4";
          this.mediaRecorder = new MediaRecorder(stream, { mimeType });
          this.recordedChunks = [];

          // 注意：不再在 onstop 中上传
          this.mediaRecorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
              this.recordedChunks.push(event.data);
            }
          };
        })
        .catch(() => {
          this.$toast && this.$toast("请允许访问摄像头和麦克风权限");
          setTimeout(() => {
            this.onBack();
          }, 1000);
        });

      // } catch (err) {
      //   this.$toast && this.$toast("请允许访问摄像头和麦克风权限");
      //   this.onBack();
      // }
    },

    startRecording() {
      if (this.isRecording || this.countdown || !this.mediaRecorder) return;

      const steps = [3, 2, 1, "开始"];
      let index = 0;
      this.countdown = String(steps[index]);

      this.countdownTimer = setInterval(() => {
        index++;
        if (index < steps.length - 1) {
          this.countdown = String(steps[index]);
        } else if (index === steps.length - 1) {
          this.countdown = "开始";
        } else {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
          this.countdown = "";
          this.mediaRecorder.start();
          this.isRecording = true;
          this.recordingTime = 0;

          // 启动录制计时器 + 45秒自动停止
          this.recordingTimer = setInterval(() => {
            this.recordingTime++;
            if (this.recordingTime >= 45) {
              this.stopRecording();
            }
          }, 1000);
        }
      }, 1000);
    },

    stopRecording() {
      if (!this.mediaRecorder || !this.isRecording) return;
      const duration = this.recordingTime;
      if (duration < 30) {
        return this.$toast && this.$toast("录制视频不可少于30秒,请继续录制");
      }
      // 先停止录制器
      this.mediaRecorder.stop();
      this.isRecording = false;

      if (this.recordingTimer) {
        clearInterval(this.recordingTimer);
        this.recordingTimer = null;
      }

      if (duration >= 30) {
        // 满足条件，上传
        setTimeout(() => {
          this.handleUpload();
        }, 500);
      } else {
        // 不足30秒：清空数据，并自动重新开始录制（带倒计时）
        this.recordedChunks = [];
        // 关键：重置倒计时状态，以便 startRecording 能执行
        if (this.countdownTimer) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
        this.countdown = ""; // 清除倒计时显示
        // 稍微延迟一下，确保 mediaRecorder 已完全停止
        this.$nextTick(() => {
          // 自动触发新一轮录制（会走 3-2-1-开始流程）
          this.startRecording();
        });
      }
    },

    async handleUpload() {
      if (this.recordedChunks.length === 0) return;
      // this.isLoading = true;
      const mimeType = this.mediaRecorder.mimeType.includes("video/mp4")
        ? "video/mp4"
        : "video/webm";
      if (mimeType == "video/webm") {
        return this.handleUploadTwice();
      }
      const blob = new Blob(this.recordedChunks, { type: mimeType });
      // 转为 File（可选，但推荐）
      const extension = mimeType === "video/mp4" ? "mp4" : "webm";
      const videoFile = new File([blob], `recording.${extension}`, {
        type: mimeType,
        lastModified: Date.now(),
      });
      const formData = new FormData();
      formData.append("audioFile", videoFile); // 后端将收到 Content-Type: video/webm
      formData.append("voType", "1");
      formData.append("spot", "1");
      const data = await voUpload(formData);
      if (data) {
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0, // 持续显示，直到关闭
        });
        const response = await fetch(data.fileUrl, {
          method: "PUT",
          mode: "cors",
          headers: {
            "Content-Type": data.fileType,
          },
          body: videoFile,
        });

        if (response.ok) {
          Toast.clear();
          this.$router.replace({
            path: "customAvatar",
          });
        } else {
          await voDelete(data.fileId);
          Toast.clear();
          this.$toast && this.$toast("上传失败，请重试");
        }
      }
    },
    // 👇 上传逻辑抽离为独立方法（这里可以用 async/await）
    async handleUploadTwice() {
      const mimeType = this.mediaRecorder.mimeType.includes("video/webm")
        ? "video/webm"
        : "video/mp4";
      const blob = new Blob(this.recordedChunks, { type: mimeType });
      const extension = mimeType === "video/mp4" ? "mp4" : "webm";
      const videoFile = new File([blob], `recording.${extension}`, {
        type: mimeType,
        lastModified: Date.now(),
      });
      const formData = new FormData();
      formData.append("audioFile", videoFile);
      let data1 = await convertWebmToMp4(formData, { responseType: "blob" });
      const blob1 = new Blob([data1.data], { type: data1.data.type });
      const extension1 = "mp4";
      const videoFile1 = new File([blob1], `recording.${extension1}`, {
        type: "video/mp4",
        lastModified: Date.now(),
      });
      try {
        const formData1 = new FormData();
        formData1.append("audioFile", videoFile1);
        formData1.append("voType", "1");
        formData1.append("spot", "1");
        const data = await voUpload(formData1);
        if (data) {
          Toast.loading({
            message: "加载中...",
            forbidClick: true,
            loadingType: "spinner",
            duration: 0,
          });

          const response = await fetch(data.fileUrl, {
            method: "PUT",
            mode: "cors",
            headers: {
              "Content-Type": "video/mp4",
            },
            body: videoFile1,
          });

          Toast.clear();

          if (response.ok) {
            this.$router.replace({ path: "customAvatar" });
          } else {
            await voDelete(data.fileId);
            this.$toast && this.$toast("上传失败，请重试");
          }
        } else {
          this.$toast && this.$toast("上传初始化失败");
        }
      } catch (err) {
        Toast.clear();
        this.$toast && this.$toast("上传异常，请重试");
      }
    },
    cleanup() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
      }
      if (this.mediaRecorder) {
        this.mediaRecorder = null;
      }
    },
  },
};
</script>

<style scoped>
/* 页面基础布局 */
.generate-result-page {
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
}

/* 导航栏 */
.custom-nav-bar {
  width: 100%;
  height: 11.7333vw;
  background-image: linear-gradient(90deg, #e7f2fa 0%, #dbe2f1 100%);
  box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
  position: relative;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-shrink: 0;
}

.back-btn {
  width: 6.4vw;
  height: 6.4vw;
  position: absolute;
  left: 2.6667vw;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.nav-title {
  font-family: SourceHanSansSC-Medium;
  font-size: 4.8vw;
  color: #000000;
  letter-spacing: 0.1333vw;
  text-align: center;
  line-height: 11.7333vw;
  font-weight: 500;
}

.topText {
  width: 91.466vw;
  /* height: 40.2666vw; */
  border-radius: 2.1333vw;
  background-color: #3d3530;
  position: fixed;
  top: 17vw;
  color: #ffffff;
  font-weight: 500;
  font-size: 3.7333vw;
  line-height: 5.466vw;
  left: 50%;
  transform: translate(-50%, 0%);
  z-index: 100;
}
.topText > div {
  padding: 3.7333vw;
}

.camera-preview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  object-fit: cover;
  z-index: 1;
  transform: scaleX(-1); /* 镜像 */
}

.control-buttons {
  position: fixed;
  bottom: 13.333vw;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

.btn {
  width: 18.666vw;
  height: 18.666vw;
  background-color: #ff1b00;
  border: 1.0666vw solid #ffffff;
  border-radius: 50%;
}
.btnStop {
  width: 18.666vw;
  height: 18.666vw;
  background-color: transparent;
  border: 1.0666vw solid #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnStop > div {
  width: 6.666vw;
  height: 6.666vw;
  border-radius: 0.2666vw;
  background-color: #ff1b00;
}

.djs {
  position: fixed;
  bottom: 48vw;
  left: 50%;
  transform: translate(-50%);
  color: #e6e1e0;
  font-weight: 700;
  font-size: 11.333vw;
  z-index: 8;
  pointer-events: none;
}

.lzsj {
  position: fixed;
  bottom: 37.333vw;
  left: 50%;
  transform: translate(-50%);
  z-index: 9;
  padding: 0 3.7333vw;
  height: 8.5333vw;
  border-radius: 6.1333vw;
  background-color: #1f222640;
  color: #ffffff;
  font-weight: 500;
  font-size: 3.7333vw;
  text-align: center;
  line-height: 8.5333vw;
}

.rxlk {
  position: fixed;
  z-index: 10;
  width: 100vw;
  height: 77.066vw;
  height: 122vw;
  top: 25vw;
  /* left: 50%; */
  /* transform: translate(-50%); */
  pointer-events: none; /* 不阻挡点击 */
}
/* 弹窗遮罩 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* 弹窗内容 */
.modal-content {
  width: 80vw;
  /* height: 58.666vw; */
  border-radius: 3.2vw;
  background-color: #ffffff;
}

.modal-title {
  line-height: 6.2666vw;
  color: #666666;
  font-weight: 500;
  font-size: 4.2666vw;
  text-align: center;
  padding: 5.333vw 0 4.2666vw 0;
}
.modal-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 6.4vw;
}
.modal-text {
  /* min-width: 44.8vw; */
  color: #666666;
  font-weight: 400;
  font-size: 3.2vw;
  line-height: 4.8vw;
  margin-top: 1.0666vw;
  text-align: center;
}

.modal-confirm-div {
  display: flex;
  justify-content: center;
  padding-bottom: 5.333vw;
}
.modal-confirm-btn {
  width: 29.333vw;
  height: 10.666vw;
  border-radius: 2.1333vw;
  background-color: #ebebed;
  line-height: 10.666vw;
  text-align: center;
  opacity: 0.8;
  color: #666666;
  font-weight: 500;
  font-size: 3.2vw;
  margin-top: 5.4666vw;
}
</style>
